// Single source of truth for the inactivity logout timing.
// Change INACTIVITY_TIMEOUT to adjust how long an idle session stays valid.
export const INACTIVITY_TIMEOUT = 60 * 60 * 1000; // 1 hour
export const SESSION_WARNING_TIME = 60 * 1000; // warn 1 minute before logout
export const SESSION_CHECK_INTERVAL = 30 * 1000; // re-check while the tab sleeps
export const LAST_ACTIVITY_KEY = 'lastActivity';

export const getLastActivity = () => {
  try {
    const value = Number(localStorage.getItem(LAST_ACTIVITY_KEY) || 0);
    return Number.isFinite(value) && value > 0 ? value : 0;
  } catch {
    return 0;
  }
};

export const isSessionExpired = (now = Date.now()) => {
  const lastActivity = getLastActivity();
  return lastActivity > 0 && now - lastActivity >= INACTIVITY_TIMEOUT;
};

export const touchSession = (now = Date.now()) => {
  try {
    localStorage.setItem(LAST_ACTIVITY_KEY, String(now));
  } catch {
    /* storage may be unavailable; the in-memory timers still work */
  }
};
